<template>
  <div>
    <modal-log :dataLog="dataLog"></modal-log>
    <modal-eliminar
      :action="action"
      :dataLog="dataLog"
      @oculto="ocultarLog"
    ></modal-eliminar>
    <b-card no-body class="p-1">
      <div v-if="!USER().is_auditor" class="misc-inner p-2 p-sm-3">
        <div class="w-100 text-center">
          <h2 class="mb-1">
            Tú no estas autorizado! 🔐
          </h2>
          <p class="mb-2">
            No tienes los permisos para ver esta página. !!
          </p>
          <b-img
            fluid
            :src="require('@/assets/images/pages/not-authorized.svg')"
            alt="Pagina no autorizada"
            style="width:50%"
          />
        </div>
      </div>
      <b-overlay v-else :show="showLoading" rounded="sm">
        <b-row>
          <b-col>
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1 mb-1"
              placeholder="Buscar por (usuario / sección / tipo / descripción)"
            />
          </b-col>
          <b-col md="4">
            <flat-pickr
              placeholder="Filtrar x fecha"
              class="form-control"
              v-model="rangeDate"
              :config="{ mode: 'range' }"
            />
          </b-col>
        </b-row>
        <b-table
          ref="refInvoiceListTable"
          :fields="tableColumns"
          :items="listLogsFilter"
          primary-key="id"
          show-empty
          responsive
          small
          empty-text="No se encontraron datos"
          class="position-relative"
          style="max-height:70vh"
          :sticky-header="true"
          :no-border-collapse="true"
        >
          <!-- Column: Id -->
          <template #cell(fecha)="data">
            <small class="text-muted">{{ data.item.fecha }}</small>
          </template>

          <!-- Column: Player -->
          <template #cell(usuario)="data">
            <b-media vertical-align="center">
              <template #aside>
                <div style="display:grid">
                  <!-- <b-avatar
                    size="32"
                    :src="data.item.foto_jug"
                    :text="avatarText(data.item.nombres)"
                  />
                  <small v-if="data.item.nuevo == 's'" class="new">New</small> -->
                </div>
              </template>
              <span
                class="font-weight-bold d-block text-nowrap text-capitalize"
              >
                {{ data.item.nombre_completo }}
              </span>
              <small class="text-muted text-capitalize">{{
                data.item.rol
              }}</small>
            </b-media>
          </template>
          <template #cell(seccion)="data">
            <small
              class="font-weight-bold d-block text-nowrap text-capitalize"
              >{{ data.item.tipo_dato }}</small
            >
          </template>

          <template #cell(fecha_nac)="data">
            <b-media vertical-align="center">
              <span class="font-weight-bold d-block text-nowrap">
                {{ data.item.accion }}
              </span>
            </b-media>
          </template>

          <template #cell(tipo)="data">
            <template>
              <b-badge
                pill
                :variant="
                  data.item.tipo === `leve`
                    ? 'light-secondary'
                    : data.item.tipo === `moderada`
                    ? 'warning'
                    : 'danger'
                "
              >
                {{ data.item.tipo }}
              </b-badge>
              <!-- <small class="text-muted">{{ data.item.fecha_calificacion }}</small> -->
            </template>
            <!-- <template v-else>
            {{ data.value }}
          </template> -->
          </template>
          <!-- Column: Actions -->
          <template #cell(opc)="data">
            <div class="text-nowrap">
              <feather-icon
                v-if="data.item.detalle != null && data.item.detalle != ''"
                icon="TrelloIcon"
                class="cursor-pointer"
                size="16"
                @click="showModalLog(data.item)"
              />
              <!-- <feather-icon
                icon="EyeOffIcon"
                class="cursor-pointer mx-1"
                size="16"
                @click="showLogEliminar(data.item, 'ocultar')"
              /> -->
              <feather-icon
                v-if="USER().rol === ROLES.SUPER"
                icon="XIcon"
                class="cursor-pointer"
                size="16"
                @click="showLogEliminar(data.item, 'eliminar')"
              />
            </div>
          </template>
        </b-table>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BOverlay,
  BTable,
  BMedia,
  BBadge,
  BFormInput,
  BRow,
  BCol,
  BImg,
  //   BIconLayers,
} from 'bootstrap-vue'
import {
  ref,
  onMounted,
  computed,
  watch,
  //   xxx,
  //   xxx,
  //   xxxx,
} from '@vue/composition-api'
import store from '@/store'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  ROLES,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
  //   ESTADO_JUGADOR,
} from '../../utils/variables'
import modalLog from './LogDetalle.vue'
import modalEliminar from './ModalConfirmacion.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BMedia,
    BBadge,
    modalLog,
    modalEliminar,
    BFormInput,
    BRow,
    BCol,
    flatPickr,
    BImg,
  },
  setup() {
    const showLoading = ref(false)
    const action = ref('ocultar')
    const searchQuery = ref('')
    const rangeDate = ref(null)
    const tableColumns = [
      { key: 'id_movimiento', label: '#', sortable: true },
      {
        key: 'fecha',
        label: 'fecha__',
        stickyColumn: true,
        sortable: true,
      },

      { key: 'usuario', sortable: true },
      // { key: 'rol', sortable: true },
      { key: 'seccion', sortable: true },
      { key: 'accion', label: 'descripcion', sortable: true },
      { key: 'tipo', sortable: true },
      { key: 'opc' },
    ]
    const listLogs = ref([])
    const dataLog = ref(null)
    const { getApi } = apiCall()

    async function getLogs(idTorneo) {
      listLogs.value = []
      showLoading.value = true
      const path = `ApiMovimientos/getMovimientos/${idTorneo}`
      const data = await getApi(URL, path)
      listLogs.value = data.data
      showLoading.value = false
    }
    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado']
    )
    watch(cambioTorneo, () => {
      getLogs(store.getters['someVariables/getTorneoSeleccionado'].id_torneo)
    })
    onMounted(() => {
      getLogs(store.getters['someVariables/getTorneoSeleccionado'].id_torneo)
      // console.log(refP.value)
    })

    function showModalLog(item) {
      dataLog.value = item
      store.commit('someVariables/UPDATE_SHOW_MODAL_LOG', true)
    }
    function showLogEliminar(item, method) {
      action.value = method
      dataLog.value = item
      store.commit('someVariables/UPDATE_SHOW_CONFIRMACION_LOG', true)
    }
    function separaFecha() {
      // console.log(rangeDate.value)
      let auxiliar = null
      if (rangeDate.value != null) {
        const arrayFechas = rangeDate.value.split('to')
        if (arrayFechas.length >= 2) {
          auxiliar = {
            valido: true,
            inicio: arrayFechas[0].trim(),
            fin: arrayFechas[1].trim(),
          }
        } else {
          auxiliar = {
            valido: true,
            inicio: arrayFechas[0].trim(),
            fin: arrayFechas[0].trim(),
          }
        }
      }
      if (rangeDate.value === '') {
        // auxiliar = {
        //   valido: false,
        //   inicio: null,
        //   fin: null,
        // }
        auxiliar = null
      }
      return auxiliar
    }

    const listLogsFilter = computed(() => {
      const fecha = separaFecha()
      let listReturn = listLogs.value
      if (fecha != null && searchQuery.value === '') {
        if (fecha.valido) {
          // eslint-disable-next-line
          listReturn = listLogs.value.filter(
            log =>
              // eslint-disable-next-line
              log.fecha >= `${fecha.inicio} 00:00:00` &&
              // eslint-disable-next-line
              log.fecha <= `${fecha.fin} 23:59:59`
            // eslint-disable-next-line
          )
        }
      } else if (fecha === null && searchQuery.value !== '') {
        // eslint-disable-next-line
        listReturn = listLogs.value.filter(
          player =>
            // eslint-disable-next-line
            player.nombre_completo
              .toLowerCase()
              .includes(searchQuery.value.toLowerCase()) ||
            // eslint-disable-next-line
            player.tipo
              .toLowerCase()
              // eslint-disable-next-line
              .includes(searchQuery.value.toLowerCase()) ||
            // eslint-disable-next-line
            player.accion
              .toLowerCase()
              // eslint-disable-next-line
              .includes(searchQuery.value.toLowerCase()) ||
            // eslint-disable-next-line
            player.tipo_dato
              .toLowerCase()
              // eslint-disable-next-line
              .includes(searchQuery.value.toLowerCase())
          // eslint-disable-next-line
        )
      } else if (fecha !== null && searchQuery.value !== '') {
        if (fecha.valido) {
          // eslint-disable-next-line
          listReturn = listLogs.value.filter(
            player =>
              // eslint-disable-next-line
              (player.nombre_completo
                .toLowerCase()
                .includes(searchQuery.value.toLowerCase()) &&
                player.fecha >= `${fecha.inicio} 00:00:00` &&
                // eslint-disable-next-line
                player.fecha <= `${fecha.fin} 23:59:59`) ||
              (player.tipo
                .toLowerCase()
                .includes(searchQuery.value.toLowerCase()) &&
                player.fecha >= `${fecha.inicio} 00:00:00` &&
                // eslint-disable-next-line
                player.fecha <= `${fecha.fin} 23:59:59`) ||
              (player.accion
                .toLowerCase()
                .includes(searchQuery.value.toLowerCase()) &&
                player.fecha >= `${fecha.inicio} 00:00:00` &&
                // eslint-disable-next-line
                player.fecha <= `${fecha.fin} 23:59:59`) ||
              (player.tipo_dato
                .toLowerCase()
                .includes(searchQuery.value.toLowerCase()) &&
                player.fecha >= `${fecha.inicio} 00:00:00` &&
                // eslint-disable-next-line
                player.fecha <= `${fecha.fin} 23:59:59`)
            // eslint-disable-next-line)
          )
        }
      }

      // listReturn = listLogs.value.filter(
      //   player =>
      //     // eslint-disable-next-line
      //     player.nombre_completo
      //       .toLowerCase()
      //       .includes(searchQuery.value.toLowerCase()) ||
      //     // eslint-disable-next-line
      //     player.rol.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
      //     // eslint-disable-next-line
      //     player.tipo.toLowerCase().includes(searchQuery.value.toLowerCase())
      //   // eslint-disable-next-line
      // )
      return listReturn
      // eslint-disable-next-line
    })
    async function ocultarLog() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'SANCION ELIMINADA exitosamente',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-bottom',
          // eslint-disable-next-line
        }
      )
      store.commit('someVariables/UPDATE_SHOW_CONFIRMACION_LOG', false)
      getLogs(store.getters['someVariables/getTorneoSeleccionado'].id_torneo)
    }

    return {
      showLoading,
      tableColumns,
      listLogs,
      showModalLog,
      modalLog,
      dataLog,
      ocultarLog,
      showLogEliminar,
      action,
      USER,
      ROLES,
      listLogsFilter,
      searchQuery,
      rangeDate,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
